var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWhatsapp = function SvgLogoWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25.703A10.52 10.52 0 0 0 .694 11.166a10.3 10.3 0 0 0 2.006 6.13l-1.313 3.892 4.05-1.285a10.556 10.556 0 0 0 16.35-8.737A10.52 10.52 0 0 0 11.25.703m5.69 13.04c-.065-.112-.253-.187-.524-.318s-1.632-.797-1.875-.89-.441-.141-.62.14-.468.684-.627.863-.319.206-.6.065a8.63 8.63 0 0 1-3.881-3.356c-.16-.272 0-.422.121-.553.46-.46.47-.394.582-.619a.5.5 0 0 0 0-.478c-.141-.16-.657-1.49-.891-2.034s-1.416-.647-1.875-.141C1.875 11.559 13.753 20.362 16.79 15a1.32 1.32 0 0 0 .15-1.238"
  })));
};
export default SvgLogoWhatsapp;